import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://www.w3schools.com/w3css/4/w3.css"
}, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "sidebar" }
const _hoisted_4 = {
  key: 0,
  src: "logo.svg",
  alt: "logo tecnospeed",
  width: "150",
  class: "white-logo m-auto mb-6"
}
const _hoisted_5 = {
  key: 1,
  src: "logo-small.svg",
  alt: "logo tecnospeed small",
  width: "30",
  class: "white-logo m-auto mb-6"
}
const _hoisted_6 = { class: "flex justify-between w-full items-center pl-5 pr-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " TECNOSPEED S/A "),
  /*#__PURE__*/_createElementVNode("div", null, " 64.690.763/0001-12 ")
], -1)
const _hoisted_8 = { class: "mt-4 dropdown inline-block relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 font-semibold py-2 rounded inline-flex items-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "fill-current h-4 w-4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" })
  ])
], -1)
const _hoisted_10 = { class: "-right-14 dropdown-menu bg-white shadow-lg w-max absolute px-4 py-5 rounded-lg hidden text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_view, null, {
      default: _withCtx(({Component, route}) => [
        (route.path != '/' && !route.path.includes('validateHash'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (route.path != '/' && route.path != '/cadastro')
                  ? (_openBlock(), _createBlock(_component_Sidebar, {
                      key: 0,
                      items: this.$store.state.sidebarMenu,
                      activeMenu: this.$store.state.sidebarActive,
                      event: "update:activeSidebar",
                      "onUpdate:activeSidebar": _ctx.updateSidebar,
                      isSidebarCollapsed: this.$store.state.isSidebarCollapsed,
                      collapseEvent: "update:collapseSidebar",
                      class: "custom-background",
                      "onUpdate:collapseSidebar": _ctx.updateCollapseSidebar
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "cursor-pointer",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/painel')))
                        }, [
                          (!this.$store.state.isSidebarCollapsed)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                            : (_openBlock(), _createElementBlock("img", _hoisted_5))
                        ])
                      ]),
                      _: 1
                    }, 8, ["items", "activeMenu", "onUpdate:activeSidebar", "isSidebarCollapsed", "onUpdate:collapseSidebar"]))
                  : _createCommentVNode("", true)
              ]),
              (route.path != '/' && route.path != '/cadastro')
                ? (_openBlock(), _createBlock(_component_Header, {
                    key: 0,
                    userData: {
        Nome: 'Matheus Amaral da Silva',
        Email: 'matheus.silva@tecnospeed.com.br',
        CNPJ: '64.690.763/0001-12'
      },
                    logOutFunction: _ctx.logout,
                    haveSidebar: true,
                    isSidebarCollapsed: this.$store.state.isSidebarCollapsed
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("ul", _hoisted_10, [
                            _createElementVNode("li", {
                              class: "cursor-pointer hover:text-primary transition mt-2",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('dados')))
                            }, " Minha empresa ")
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["userData", "logOutFunction", "isSidebarCollapsed"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
          class: _normalizeClass(["transition-all ease-out-in duration-500", route.path != '/' && route.path != '/cadastro' ? this.$store.state.isSidebarCollapsed ? 'ml-24 -md:ml-0' : 'ml-64 -lg:ml-24 -md:ml-0' : '' ])
        }, null, 8, ["class"]))
      ]),
      _: 1
    })
  ], 64))
}